(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-component-panel"] && !Shopify.designMode) return;
  try {
    // One section open at a time. In the phone accordion the open section's
  // "−" closes it again, like every other +/− row on the page. In the
  // wide-screen tab row a click only ever selects, so the row can't end up
  // with nothing showing; the same 48rem breakpoint as the stylesheet
  // decides which of the two it is.
  (function () {
    var tabRow = window.matchMedia('(min-width: 48rem)');

    var select = function (group, tab) {
      group.querySelectorAll('[data-panel-tab]').forEach(function (other) {
        var isTarget = other === tab;
        other.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
        var panel = document.getElementById(other.getAttribute('aria-controls'));
        if (panel) panel.hidden = !isTarget;
      });
    };

    document.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-panel-tab]');
      if (!tab) return;

      var group = tab.closest('.cns-component-panel__sections');
      if (!group) return;

      var closing = !tabRow.matches && tab.getAttribute('aria-expanded') === 'true';
      select(group, closing ? null : tab);
    });

    // An accordion left fully closed would be an empty tab row once the
    // window grows past the breakpoint (a tablet turned sideways).
    tabRow.addEventListener('change', function () {
      if (!tabRow.matches) return;
      document.querySelectorAll('.cns-component-panel__sections').forEach(function (group) {
        if (group.querySelector('[data-panel-tab][aria-expanded="true"]')) return;
        var first = group.querySelector('[data-panel-tab]');
        if (first) select(group, first);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["catalog-header"] && !Shopify.designMode) return;
  try {
    // The grouped catalogue's tabs (catalog-header.liquid): a tab jumps to its
  // group, and while the reader scrolls the group under the reading line is
  // the current tab, as in the kit page's section nav (section-nav.liquid):
  // green, underlined, and kept in view in the sideways-scrolling strip.
  // <cns-catalog> swaps the list in place after a filter or a sort, so the
  // tabs and groups are looked up afresh on every frame rather than kept.
  (function () {
    if (window.__cnsCatalogSpy) return;
    window.__cnsCatalogSpy = true;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    var reveal = function (strip, link) {
      if (!strip || strip.scrollWidth <= strip.clientWidth) return;
      var stripBox = strip.getBoundingClientRect();
      var linkBox = link.getBoundingClientRect();
      if (linkBox.left >= stripBox.left && linkBox.right <= stripBox.right) return;
      strip.scrollTo({
        left: strip.scrollLeft + linkBox.left - stripBox.left - (stripBox.width - linkBox.width) / 2,
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
      });
    };

    var update = function () {
      var nav = document.querySelector('.cns-catalog__tabs');
      if (!nav) return;
      document.documentElement.style.setProperty('--cns-catalog-tabs-height', nav.offsetHeight + 'px');
      var links = Array.prototype.slice.call(nav.querySelectorAll('a[data-catalog-anchor]'));
      if (!links.length) return;
      var navBox = nav.getBoundingClientRect();
      // Until the strip has reached its sticky place (the page has not been
      // scrolled down to the products yet), "Wszystkie" is the current tab.
      var stuck = navBox.top <= parseFloat(getComputedStyle(nav).top) + 1;
      var line = navBox.bottom + Math.min(window.innerHeight * 0.3, 240);
      var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
      var next = links[0];
      var bestTop = -Infinity;
      links.forEach(function (link, index) {
        if (index === 0 || !stuck) return;
        var group = document.getElementById(link.dataset.catalogAnchor);
        if (!group) return;
        var top = group.getBoundingClientRect().top;
        var reached = top <= line || (atBottom && top < window.innerHeight);
        if (reached && top > bestTop) {
          next = link;
          bestTop = top;
        }
      });
      if (next.hasAttribute('aria-current')) return;
      links.forEach(function (link) { link.removeAttribute('aria-current'); });
      next.setAttribute('aria-current', 'true');
      reveal(nav.querySelector('[data-catalog-tabs]'), next);
    };

    window.cnsOnScrollFrame(update);

    // Scrolls a group to just under the tab strip. The offset is worked out
    // for where the scroll ends, not where it starts: on a phone the site
    // header slides away on the way down and comes back on the way up
    // (header.liquid), so a native jump measured from the start landed a
    // group too low going down and under the strip going up.
    var phone = window.matchMedia('(max-width: 47.9375rem)');
    var jumpTo = function (target, smooth) {
      var nav = document.querySelector('.cns-catalog__tabs');
      var header = document.querySelector('cns-sticky-nav');
      var guarantee = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cns-guarantee-height')) || 0;
      var top = target.getBoundingClientRect().top;
      var headerShown = !phone.matches || top < 0;
      var offset = guarantee + (header && headerShown ? header.getBoundingClientRect().height : 0) + (nav ? nav.offsetHeight : 0) + 16;
      window.scrollTo({ top: window.scrollY + top - offset, behavior: smooth && !reduceMotion.matches ? 'smooth' : 'instant' });
    };

    // A jump on the same page; the address keeps the group's hash, so the
    // link can be shared or used in an ad.
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[data-catalog-anchor]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var target = document.getElementById(link.dataset.catalogAnchor);
      if (!target) return;
      event.preventDefault();
      jumpTo(target, true);
      history.replaceState(history.state, '', '#' + link.dataset.catalogAnchor);
    });

    // Arriving with a group's hash (a tab on a category page, a shared
    // link): the same placement once the page has laid out.
    var placeHashGroup = function () {
      var hash = window.location.hash.slice(1);
      var target = hash && document.querySelector('.cns-catalog__group[id="' + hash.replace(/"/g, '') + '"]');
      if (!target) return;
      // The browser's own (smooth) hash jump and the header's slide can run
      // on past the load event, so the group is placed once the page has
      // stopped scrolling for a moment (at most three seconds in).
      var quiet = null;
      var started = Date.now();
      var settle = function () {
        window.clearTimeout(quiet);
        quiet = window.setTimeout(function () {
          window.removeEventListener('scroll', settle);
          jumpTo(target, false);
        }, Date.now() - started > 3000 ? 0 : 250);
      };
      window.addEventListener('scroll', settle, { passive: true });
      settle();
    };
    // Theme scripts can run after the load event, so check which came first.
    if (document.readyState === 'complete') placeHashGroup();
    else window.addEventListener('load', placeHashGroup);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["catalog-quick-buy"] && !Shopify.designMode) return;
  try {
    // One panel serves every card: the product's own quick-buy section is
  // fetched on the first ask and kept, so a second look at the same card
  // opens at once.
  (function () {
    if (window.__cnsQuickBuy) return;
    window.__cnsQuickBuy = true;

    var cache = new Map();
    var lastTrigger = null;
    var requestId = 0;

    function panel() {
      return document.querySelector('[data-quick-buy-panel]');
    }

    function setStatus(dialog, text) {
      var body = dialog.querySelector('[data-quick-buy-body]');
      body.innerHTML = '';
      var status = document.createElement('p');
      status.className = 'cns-quick-buy-panel__status';
      status.setAttribute('role', 'status');
      status.setAttribute('data-quick-buy-status', '');
      status.textContent = text;
      body.appendChild(status);
    }

    function fetchContent(url) {
      if (cache.has(url)) return cache.get(url);
      // A request that hangs is given up after 8 s and treated as failed.
      var options = { credentials: 'same-origin' };
      if (window.AbortSignal && AbortSignal.timeout) options.signal = AbortSignal.timeout(8000);
      var request = fetch(url, options)
        .then(function (response) {
          if (!response.ok) throw new Error('Quick buy request failed: ' + response.status);
          return response.text();
        });
      request.catch(function () {
        cache.delete(url);
      });
      cache.set(url, request);
      return request;
    }

    // A product that could not be fetched: said in the panel, with a retry
    // and the product page one tap away, instead of a silent jump to that
    // page (audit G006).
    function setFailed(dialog, productUrl, retry) {
      var body = dialog.querySelector('[data-quick-buy-body]');
      body.innerHTML = '';
      var box = document.createElement('div');
      box.className = 'cns-quick-buy-panel__failed';
      var text = document.createElement('p');
      text.className = 'cns-quick-buy-panel__status';
      text.setAttribute('role', 'status');
      text.textContent = dialog.dataset.errorText || '';
      var again = document.createElement('button');
      again.type = 'button';
      again.className = 'cns-button cns-button--small cns-quick-buy-panel__retry';
      again.textContent = dialog.dataset.retryText || '';
      again.addEventListener('click', retry);
      var link = document.createElement('a');
      link.href = productUrl;
      link.textContent = dialog.dataset.detailsText || '';
      box.append(text, again, link);
      body.appendChild(box);
      again.focus({ preventScroll: true });
    }

    function focusFirst(dialog) {
      var field = dialog.querySelector(
        '[data-quick-buy-body] input:not([type="hidden"]), [data-quick-buy-body] button, [data-quick-buy-body] a'
      );
      if (field) field.focus({ preventScroll: true });
    }

    function shownHandle(dialog) {
      var content = dialog.querySelector('[data-quick-buy-content]');
      return content ? content.dataset.quickBuyHandle : null;
    }

    // What the trigger asked to add with the product: the line under the
    // price and the hidden inputs the buy form reads. Cleared first, so a
    // plain trigger for the same product opens it without leftovers.
    function applyAddons(dialog, trigger) {
      var content = dialog.querySelector('[data-quick-buy-content]');
      if (!content) return;
      content.querySelectorAll('[data-quick-buy-addon]').forEach(function (el) {
        el.remove();
      });
      // The big price line comes back for a plain trigger; with add-ons the
      // summary below names the kit's price, so the line would say it twice.
      content.querySelectorAll('.cns-price, .cns-price-facts').forEach(function (el) {
        el.style.display = '';
      });
      var ids = trigger && trigger.dataset.addonIds ? trigger.dataset.addonIds.split(',').filter(Boolean) : [];
      var buyForm = content.querySelector('product-buy-form');
      var form = buyForm && buyForm.querySelector('form');
      if (!ids.length || !form) return;

      ids.forEach(function (id) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.value = id;
        input.setAttribute('data-buy-addon', '');
        input.setAttribute('data-quick-buy-addon', '');
        form.appendChild(input);
      });

      // The sum the strip promised, itemised the way the strip was: the
      // kit, "+" each add-on, "Razem" (audit V005, V110). The kit's row and
      // the total read the selected flavour's price and follow every later
      // change (see the cns:variant-change listener), so "Razem" appears
      // once and only as the sum.
      var rows = (trigger.dataset.addonRows || '').split('||').filter(Boolean);
      if (!rows.length || typeof buyForm.formatMoney !== 'function') return;
      var sum = document.createElement('dl');
      sum.className = 'cns-quick-buy__addon cns-quick-buy__sum';
      sum.setAttribute('data-quick-buy-addon', '');
      sum.setAttribute('data-quick-buy-sum', '');
      sum.dataset.addonCents = trigger.dataset.addonCents || '';
      var addRow = function (label, price, cls, mark) {
        var name = document.createElement('dt');
        name.textContent = label;
        var value = document.createElement('dd');
        value.textContent = price;
        if (cls) { name.className = cls; value.className = cls; }
        if (mark) value.setAttribute(mark, '');
        sum.appendChild(name);
        sum.appendChild(value);
      };
      addRow(trigger.dataset.kitTitle || '', '', 'cns-quick-buy__sum-kit', 'data-quick-buy-sum-kit');
      rows.forEach(function (row) {
        var parts = row.split('|');
        addRow('+ ' + parts[0], buyForm.formatMoney(Number(parts[1])), 'cns-quick-buy__sum-addon', '');
      });
      addRow(dialog.dataset.totalText || '', '', 'cns-quick-buy__sum-total', 'data-quick-buy-sum-total');
      buyForm.parentNode.insertBefore(sum, buyForm);
      content.querySelectorAll('.cns-price, .cns-price-facts').forEach(function (el) {
        el.style.display = 'none';
      });
      renderTotal(dialog);
    }

    // The kit's row and "Razem" for the variant the panel's form holds
    // right now, in the shop's money format.
    function renderTotal(dialog) {
      var sum = dialog.querySelector('[data-quick-buy-sum]');
      if (!sum || sum.dataset.addonCents === '') return;
      var buyForm = dialog.querySelector('product-buy-form');
      var idInput = buyForm && buyForm.querySelector('input[name="id"]');
      var json = buyForm && buyForm.querySelector('[data-buy-form-variants]');
      if (!idInput || !json || typeof buyForm.formatMoney !== 'function') return;
      var variants;
      try { variants = JSON.parse(json.textContent); } catch (e) { return; }
      var current = variants.find(function (v) { return String(v.id) === String(idInput.value); });
      if (!current) return;
      var kitCell = sum.querySelector('[data-quick-buy-sum-kit]');
      var totalCell = sum.querySelector('[data-quick-buy-sum-total]');
      if (kitCell) kitCell.textContent = buyForm.formatMoney(Number(current.price));
      if (totalCell) totalCell.textContent = buyForm.formatMoney(Number(current.price) + Number(sum.dataset.addonCents));
    }

    document.addEventListener('cns:variant-change', function () {
      var dialog = panel();
      if (dialog && dialog.open) renderTotal(dialog);
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('a[data-quick-buy]');
      if (!trigger) return;
      // A modified click keeps opening the product page in its own tab.
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var dialog = panel();
      if (!dialog || typeof dialog.showModal !== 'function' || !window.fetch) return;
      // Without the buy form's script a fetched form would look right and
      // buy the wrong flavour: the link opens the product page instead.
      if (!window.customElements || !customElements.get('product-buy-form')) return;

      event.preventDefault();
      lastTrigger = trigger;

      var handle = trigger.dataset.quickBuy;

      // Already holding this product (the last one opened), so it shows
      // at once; a request still on its way is no longer wanted.
      if (handle && shownHandle(dialog) === handle) {
        requestId++;
        applyAddons(dialog, trigger);
        if (!dialog.open) dialog.showModal();
        focusFirst(dialog);
        return;
      }

      var productUrl = trigger.href;
      var sectionUrl = new URL(productUrl, window.location.href);
      sectionUrl.searchParams.set('section_id', 'quick-buy');

      if (!dialog.open) dialog.showModal();

      // Also what "Spróbuj ponownie" runs after a failed fetch.
      function load() {
        var id = ++requestId;
        setStatus(dialog, dialog.dataset.loadingText || '');
        fetchContent(sectionUrl.href)
          .then(function (html) {
            if (id !== requestId || !dialog.open) return;
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var content = parsed.querySelector('[data-quick-buy-content]');
            if (!content) throw new Error('Quick buy content missing');

            // Parsed elsewhere, the buy form would arrive as inert markup:
            // a custom element adopted from a DOMParser document is never
            // upgraded. Written as HTML, this document's parser builds it
            // and <product-buy-form> comes to life.
            dialog.querySelector('[data-quick-buy-body]').innerHTML = content.outerHTML;
            applyAddons(dialog, trigger);
            focusFirst(dialog);
          })
          .catch(function () {
            if (id !== requestId || !dialog.open) return;
            setFailed(dialog, productUrl, load);
          });
      }
      load();
    });

    // The add went through: the header is opening the cart panel, so this
    // one steps aside rather than stacking under it.
    document.addEventListener('cns:cart-refresh', function (event) {
      if (!event.detail || !event.detail.added) return;
      var dialog = panel();
      if (dialog && dialog.open) dialog.close();
    });

    // panel-frame.liquid returns focus for its own triggers; this panel
    // opens from a link it does not know about.
    document.addEventListener(
      'close',
      function (event) {
        var dialog = event.target;
        if (!dialog.hasAttribute || !dialog.hasAttribute('data-quick-buy-panel')) return;
        // A request still on its way is no longer wanted, but whatever is
        // on screen stays: opening that product again costs nothing.
        requestId++;
        if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
        lastTrigger = null;
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["catalog-toolbar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cns-catalog')) {
    customElements.define(
      'cns-catalog',
      class CnsCatalog extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.cache = new Map();
          this.loadId = 0;
          this.currentUrl = window.location.href;
          this.classList.add('is-enhanced');

          this.onClick = this.onClick.bind(this);
          this.onChange = this.onChange.bind(this);
          this.onSubmit = this.onSubmit.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
          this.onToggle = this.onToggle.bind(this);
          this.onPrefetch = this.onPrefetch.bind(this);
          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onPopState = this.onPopState.bind(this);
          this.updateTabsFade = this.updateTabsFade.bind(this);

          this.addEventListener('click', this.onClick);
          this.addEventListener('change', this.onChange);
          this.addEventListener('submit', this.onSubmit);
          this.addEventListener('keydown', this.onKeydown);
          // `toggle` does not bubble, so it is caught on the way down.
          this.addEventListener('toggle', this.onToggle, true);
          this.addEventListener('pointerover', this.onPrefetch);
          this.addEventListener('focusin', this.onPrefetch);
          document.addEventListener('click', this.onDocumentClick);
          window.addEventListener('popstate', this.onPopState);

          window.history.replaceState({ ...window.history.state, cnsCatalog: true }, '');

          this.tabsObserver = new ResizeObserver(this.updateTabsFade);
          this.setupTabs({ center: true });
          this.syncViewButtons();
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
          window.removeEventListener('popstate', this.onPopState);
          this.tabsObserver?.disconnect();
        }

        get content() {
          return this.querySelector('[data-catalog-content]');
        }

        onClick(event) {
          const viewButton = event.target.closest('[data-catalog-view]');
          if (viewButton && this.contains(viewButton)) {
            this.setView(viewButton.dataset.catalogView, viewButton.dataset.catalogViewValue);
            return;
          }

          const link = event.target.closest('a[data-catalog-link]');
          if (!link || !this.contains(link)) return;
          if (event.defaultPrevented || event.button !== 0) return;
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (link.target && link.target !== '_self') return;

          event.preventDefault();
          // `data-catalog-scroll` alone means the top of the catalog;
          // pagination asks for `results`.
          const scroll = link.hasAttribute('data-catalog-scroll') ? link.dataset.catalogScroll || 'top' : null;
          this.load(link.href, { scroll });
        }

        onChange(event) {
          const field = event.target;
          if (!field.matches('[data-catalog-autosubmit]') || !field.form) return;
          this.submit(field.form);
        }

        onSubmit(event) {
          const form = event.target;
          if (form.matches('[data-catalog-add]')) {
            this.addToCart(event, form);
            return;
          }
          if (!form.matches('[data-catalog-form]')) return;
          event.preventDefault();
          // An explicit "Zastosuj" (or Enter in the price fields) is the
          // reader saying they are done, so the dropdown closes; ticking a
          // checkbox leaves it open for the next tick.
          form.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
          this.submit(form);
        }

        submit(form) {
          const params = new URLSearchParams();
          for (const [name, value] of new FormData(form)) {
            if (typeof value !== 'string' || value.trim() === '') continue;
            if (name === 'sort_by' && value === form.elements.sort_by?.dataset.defaultValue) continue;
            params.append(name, value.trim());
          }
          const url = new URL(form.action, window.location.href);
          url.search = params.toString();
          this.load(url.href);
        }

        // --- view switcher ---
        // The choice lives on this element (the stylesheet reads it) and in
        // the browser, so it holds across pages. An early script in
        // catalog-header.liquid applies the stored one before first paint;
        // this only has to keep the buttons and the store in step.
        setView(kind, value) {
          if (kind === 'columns') this.dataset.mobileColumns = value;
          if (kind === 'layout') this.dataset.view = value;
          try {
            window.localStorage.setItem(`cns-catalog-${kind}`, value);
          } catch (error) {
            // A browser with storage switched off keeps the choice for this page only.
          }
          this.syncViewButtons();
        }

        syncViewButtons() {
          const current = { columns: this.dataset.mobileColumns || '2', layout: this.dataset.view || 'grid' };
          this.querySelectorAll('[data-catalog-view]').forEach((button) => {
            const on = current[button.dataset.catalogView] === button.dataset.catalogViewValue;
            button.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        }

        // Tells the shopper why an add from a card did not happen: a line
        // under that card's buttons, and the same words in the page's status
        // region for a screen reader. Never a plain resubmit: Shopify answers
        // a refused one with its own English error page, and after a lost
        // response the retry could add the product twice (audit G050).
        showAddError(form, message) {
          if (!message) return;
          const actions = form.closest('.cns-catalog-card__actions');
          const card = actions ? actions.parentElement : form.parentElement;
          let line = card.querySelector('[data-catalog-add-error]');
          if (!line) {
            line = document.createElement('p');
            line.className = 'cns-catalog-card__error';
            line.setAttribute('data-catalog-add-error', '');
            card.appendChild(line);
          }
          line.textContent = message;
          const status = this.querySelector('[data-catalog-status]');
          if (status) status.textContent = message;
        }

        // --- add to cart from a card ---
        // The same path product-buy-form-script.liquid takes: post to
        // /cart/add.js, ask for the section that draws the cart in the same
        // round trip and hand it to header.liquid, which swaps the panel and
        // opens it. Without JavaScript or a cart panel, the form posts on
        // its own to /cart/add.
        addToCart(event, form) {
          if (form.dataset.busy) {
            event.preventDefault();
            return;
          }
          const button = form.querySelector('[type="submit"]');
          // The shared request lives in header.liquid (window.cnsAddToCart);
          // without it, or without a cart panel, the form submits as usual.
          const request = window.cnsAddToCart
            ? window.cnsAddToCart(this.dataset.cartAddUrl, new FormData(form), button)
            : null;
          if (!request) return;
          event.preventDefault();
          form.dataset.busy = 'true';
          button?.setAttribute('aria-busy', 'true');
          form.closest('.cns-catalog-card__actions')?.parentElement.querySelector('[data-catalog-add-error]')?.remove();

          request
            .then(({ outcome }) => {
              if (outcome === 'offline') this.showAddError(form, this.dataset.addOfflineText);
              else if (outcome === 'refused') this.showAddError(form, this.dataset.addErrorText);
              else if (outcome === 'no-panel') window.location.assign(this.dataset.cartUrl);
            })
            .finally(() => {
              delete form.dataset.busy;
              button?.removeAttribute('aria-busy');
            });
        }

        onKeydown(event) {
          if (event.key !== 'Escape') return;
          const open = event.target.closest('details[open]');
          if (!open || !this.contains(open)) return;
          open.removeAttribute('open');
          open.querySelector('summary')?.focus();
        }

        // One dropdown open at a time.
        onToggle(event) {
          const details = event.target;
          if (!(details instanceof HTMLDetailsElement) || !details.open) return;
          this.querySelectorAll('details[open]').forEach((other) => {
            if (other !== details) other.removeAttribute('open');
          });
        }

        onDocumentClick(event) {
          this.querySelectorAll('details[open]').forEach((details) => {
            if (!details.contains(event.target)) details.removeAttribute('open');
          });
        }

        // Starts fetching a tab or page link the moment a mouse pointer or
        // keyboard focus reaches it, so the click itself usually finds the
        // answer waiting. Touch does not prefetch: a finger sliding the tab
        // strip would fetch every tab it crosses (audit F244).
        onPrefetch(event) {
          if (event.type === 'pointerover' && event.pointerType !== 'mouse') return;
          const link = event.target.closest?.('a[data-catalog-link]');
          if (!link || !this.contains(link)) return;
          this.fetchSection(link.href).catch(() => {});
        }

        onPopState(event) {
          if (!event.state?.cnsCatalog) return;
          if (this.stripHash(window.location.href) === this.stripHash(this.currentUrl)) return;
          this.load(window.location.href, { push: false });
        }

        stripHash(url) {
          return url.split('#')[0];
        }

        fetchSection(url) {
          const key = this.stripHash(new URL(url, window.location.href).href);
          if (this.cache.has(key)) return this.cache.get(key);

          const requestUrl = new URL(key);
          requestUrl.searchParams.set('section_id', this.sectionId);
          const request = fetch(requestUrl, { credentials: 'same-origin' }).then(
            (response) => {
              if (!response.ok) throw new Error(`Catalog request failed: ${response.status}`);
              return response.text();
            },
            (error) => {
              // No answer at all: the connection, not the server.
              error.cnsOffline = true;
              throw error;
            }
          );
          request.catch(() => this.cache.delete(key));

          this.cache.set(key, request);
          if (this.cache.size > 30) this.cache.delete(this.cache.keys().next().value);
          return request;
        }

        async load(url, { push = true, scroll = null } = {}) {
          const target = new URL(url, window.location.href);
          target.searchParams.delete('section_id');
          const loadId = ++this.loadId;
          const busyTimer = window.setTimeout(() => this.setAttribute('aria-busy', 'true'), 120);

          try {
            const html = await this.fetchSection(target.href);
            if (loadId !== this.loadId) return;

            const doc = new DOMParser().parseFromString(html, 'text/html');
            const next = doc.querySelector('cns-catalog');
            const nextContent = next?.querySelector('[data-catalog-content]');
            if (!next || next.dataset.sectionId !== this.sectionId || !nextContent) {
              throw new Error('Catalog section missing from the response');
            }

            this.render(next, nextContent);
            if (push) window.history.pushState({ cnsCatalog: true }, '', target.href);
            this.currentUrl = target.href;
            if (scroll === 'top') this.scrollToStart();
            if (scroll === 'results') this.scrollToResults();
          } catch (error) {
            if (loadId !== this.loadId) return;
            // Without a connection the list the shopper had stays, with a
            // line saying why, instead of the browser's offline page (audit
            // G056). Any other failure loads the page itself, which shows
            // whatever the server can.
            if (error && error.cnsOffline) {
              this.showLoadError();
            } else {
              window.location.assign(target.href);
            }
          } finally {
            window.clearTimeout(busyTimer);
            if (loadId === this.loadId) this.removeAttribute('aria-busy');
          }
        }

        showLoadError() {
          const results = this.querySelector('[data-catalog-results]');
          if (!results) return;
          let note = results.querySelector('[data-catalog-load-error]');
          if (!note) {
            note = document.createElement('p');
            note.className = 'cns-catalog__load-error';
            note.setAttribute('role', 'alert');
            note.setAttribute('data-catalog-load-error', '');
            results.prepend(note);
          }
          note.textContent = this.dataset.addOfflineText || '';
        }

        render(next, nextContent) {
          const openFilter = this.querySelector('details[open][data-filter-key]')?.dataset.filterKey;
          const active = document.activeElement;
          let focusSelector = null;
          if (active && this.contains(active)) {
            if (active.id) focusSelector = `#${CSS.escape(active.id)}`;
            else if (active.dataset.focusKey) focusSelector = `[data-focus-key="${CSS.escape(active.dataset.focusKey)}"]`;
          }
          const tabsScroll = this.querySelector('[data-catalog-tabs]')?.scrollLeft ?? 0;

          this.content.replaceChildren(...nextContent.childNodes);

          if (next.dataset.title) document.title = next.dataset.title;
          const status = this.querySelector('[data-catalog-status]');
          if (status) status.textContent = next.dataset.announce || '';

          if (openFilter) {
            this.querySelector(`details[data-filter-key="${CSS.escape(openFilter)}"]`)?.setAttribute('open', '');
          }
          if (focusSelector) this.querySelector(focusSelector)?.focus({ preventScroll: true });

          const scroller = this.querySelector('[data-catalog-tabs]');
          if (scroller) scroller.scrollLeft = tabsScroll;
          this.setupTabs({ center: false });
          this.syncViewButtons();
        }

        // Back to the top of the catalog when a tab changes the list, but
        // only if the reader has scrolled past it.
        scrollToStart() {
          const intro = this.querySelector('.cns-catalog__intro') || this;
          if (intro.getBoundingClientRect().top < 0) intro.scrollIntoView({ block: 'start' });
        }

        scrollToResults() {
          const results = this.querySelector('[data-catalog-results]');
          if (results && results.getBoundingClientRect().top < 0) results.scrollIntoView({ block: 'start' });
        }

        setupTabs({ center }) {
          const scroller = this.querySelector('[data-catalog-tabs]');
          this.tabsObserver.disconnect();
          if (!scroller) return;

          scroller.addEventListener('scroll', this.updateTabsFade, { passive: true });
          this.tabsObserver.observe(scroller);

          // Brings the current tab into view inside the strip, without
          // scrolling the page itself.
          const current = scroller.querySelector('[aria-current]');
          if (current && scroller.scrollWidth > scroller.clientWidth) {
            const start = current.offsetLeft - scroller.offsetLeft;
            const end = start + current.offsetWidth;
            const visibleStart = scroller.scrollLeft;
            const visibleEnd = visibleStart + scroller.clientWidth;
            if (center || start < visibleStart || end > visibleEnd) {
              scroller.scrollTo({
                left: start - (scroller.clientWidth - current.offsetWidth) / 2,
                behavior: center ? 'auto' : 'smooth',
              });
            }
          }
          this.updateTabsFade();
        }

        updateTabsFade() {
          const scroller = this.querySelector('[data-catalog-tabs]');
          if (!scroller) return;
          const maxScroll = scroller.scrollWidth - scroller.clientWidth;
          scroller.classList.toggle('is-clipped-start', scroller.scrollLeft > 2);
          scroller.classList.toggle('is-clipped-end', scroller.scrollLeft < maxScroll - 2);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit-addons"] && !Shopify.designMode) return;
  try {
    // The add-on row's two jobs, both in place on the kit page:
  // "Dodaj do koszyka" on a card or in a panel's foot sends the same
  // request as the catalog cards (window.cnsAddToCart in header.liquid),
  // which opens the cart panel; "Szczegóły produktu" and the photo open the
  // add-on's panel, fetched once from sections/addon-panel.liquid.
  (function () {
    if (window.__cnsKitAddons) return;
    window.__cnsKitAddons = true;
    var loading = {};

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function showError(form, message) {
      var holder = form.closest('.cns-addon__action') || form.parentElement;
      if (!holder || !message) return;
      var line = holder.querySelector('.cns-addon__error');
      if (!line) {
        line = document.createElement('p');
        line.className = 'cns-addon__error';
        line.setAttribute('role', 'status');
        holder.appendChild(line);
      }
      line.textContent = message;
    }

    // The add-on's panel from its own section, asked for again once if an
    // answer comes back without it (a dropped or empty response). Gives up
    // after 8 s, and a 404/429/500 counts as no answer (audit H022).
    function fetchPanel(handle, id, tries) {
      var options = {};
      if (window.AbortSignal && AbortSignal.timeout) options.signal = AbortSignal.timeout(8000);
      return fetch(root() + 'products/' + encodeURIComponent(handle) + '?section_id=addon-panel', options)
        .then(function (response) {
          if (!response.ok) throw new Error('status ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var dialog = new DOMParser().parseFromString(html, 'text/html').getElementById(id);
          if (dialog) return dialog;
          if (tries > 1) return fetchPanel(handle, id, tries - 1);
          throw new Error('no panel');
        });
    }

    function openPanel(dialog, trigger) {
      if (!dialog || typeof dialog.showModal !== 'function') return false;
      if (!dialog.open) dialog.showModal();
      dialog.cnsTrigger = trigger;
      return true;
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-addon-details]');
      if (!trigger) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var band = trigger.closest('.cns-addons');
      var handle = trigger.dataset.addonDetails;
      if (!band || !handle || !window.fetch) return;
      event.preventDefault();
      var id = 'addon-panel-' + handle;
      if (openPanel(document.getElementById(id), trigger)) return;
      if (loading[handle]) return;
      loading[handle] = true;
      var link = band.querySelector('a[data-addon-details="' + handle + '"]');
      var productUrl = link ? link.getAttribute('href') : root() + 'products/' + handle;
      if (link) link.setAttribute('aria-busy', 'true');
      var card = trigger.closest('.cns-addon');
      var oldError = card && card.querySelector('.cns-addon__error');
      if (oldError) oldError.textContent = '';
      fetchPanel(handle, id, 2)
        .then(function (dialog) {
          band.appendChild(dialog);
          if (!openPanel(dialog, trigger)) window.location.assign(productUrl);
        })
        .catch(function () {
          // Said at the card, which stays clickable for another try: the
          // shopper keeps the kit page they came to (audit H022).
          var holder = card && (card.querySelector('.cns-addon__action') || card);
          if (!holder) return;
          var line = holder.querySelector('.cns-addon__error');
          if (!line) {
            line = document.createElement('p');
            line.className = 'cns-addon__error';
            line.setAttribute('role', 'status');
            holder.appendChild(line);
          }
          line.textContent = band.dataset.panelErrorText || '';
        })
        .finally(function () {
          loading[handle] = false;
          if (link) link.removeAttribute('aria-busy');
        });
    });

    // Back to whatever opened the panel, as panel-frame.liquid does for the
    // kit's own panels (`close` does not bubble).
    document.addEventListener(
      'close',
      function (event) {
        var dialog = event.target;
        if (!dialog.id || dialog.id.indexOf('addon-panel-') !== 0 || !dialog.cnsTrigger) return;
        var back = dialog.cnsTrigger.closest('.cns-addon');
        var focusable = back && back.querySelector('a[data-addon-details]');
        if (focusable) focusable.focus();
        dialog.cnsTrigger = null;
      },
      true
    );

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('[data-addon-add]')) return;
      var band = form.closest('.cns-addons');
      if (!band || !window.cnsAddToCart) return;
      if (form.dataset.busy) {
        event.preventDefault();
        return;
      }
      var button = form.querySelector('[type="submit"]');
      var request = window.cnsAddToCart(band.dataset.addUrl, new FormData(form), button);
      if (!request) return;
      event.preventDefault();
      form.dataset.busy = 'true';
      if (button) button.setAttribute('aria-busy', 'true');
      var holder = form.closest('.cns-addon__action') || form.parentElement;
      var old = holder && holder.querySelector('.cns-addon__error');
      if (old) old.remove();
      request
        .then(function (result) {
          if (result.outcome === 'added') {
            // Added from a panel: the cart panel takes its place.
            var panel = form.closest('dialog');
            if (panel && panel.open) panel.close();
          } else if (result.outcome === 'offline') showError(form, band.dataset.addOfflineText);
          else if (result.outcome === 'refused') showError(form, band.dataset.addErrorText);
          else if (result.outcome === 'no-panel') window.location.assign(band.dataset.cartUrl);
        })
        .finally(function () {
          delete form.dataset.busy;
          if (button) button.removeAttribute('aria-busy');
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["page-panel"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cnsPagePanel) return;
    window.__cnsPagePanel = true;
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-open-panel]');
      if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var dialog = document.getElementById(trigger.dataset.openPanel);
      var box = dialog && dialog.querySelector('[data-panel-src]');
      if (!box || box.dataset.loaded) return;
      box.dataset.loaded = '1';
      var options = {};
      if (window.AbortSignal && AbortSignal.timeout) options.signal = AbortSignal.timeout(8000);
      fetch(box.dataset.panelSrc, options)
        .then(function (response) {
          if (!response.ok) throw new Error('status ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-panel-content]');
          if (!content) throw new Error('no content');
          box.innerHTML = content.innerHTML;
          box.removeAttribute('aria-busy');
        })
        .catch(function () {
          // The page itself, as the link would without the panel.
          if (trigger.href) window.location.assign(trigger.href);
          else delete box.dataset.loaded;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["panel-frame"] && !Shopify.designMode) return;
  try {
    // Esc and the focus trap come free with showModal().
  (function () {
    var lastTrigger = null;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-open-panel]');
      if (trigger) {
        // A link trigger keeps its href for a new tab or window.
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var dialog = document.getElementById(trigger.dataset.openPanel);
        if (dialog && typeof dialog.showModal === 'function') {
          event.preventDefault();
          lastTrigger = trigger;
          if (!dialog.open) dialog.showModal();
        }
        return;
      }

      var closeBtn = event.target.closest('[data-panel-close]');
      if (closeBtn) {
        var openDialog = closeBtn.closest('dialog.cns-component-panel');
        if (openDialog) openDialog.close();
        return;
      }

      // A click landing on the <dialog> element itself, outside its inner
      // box, is a backdrop click — ::backdrop is not a click target. Scoped
      // to this frame so the header's drawers keep their own behaviour.
      if (event.target.classList.contains('cns-component-panel') && event.target.open) {
        event.target.close();
      }
    });

    // `close` does not bubble, so this listens in the capture phase.
    document.addEventListener(
      'close',
      function (event) {
        if (event.target.classList.contains('cns-component-panel') && lastTrigger) {
          if (document.contains(lastTrigger)) lastTrigger.focus();
          lastTrigger = null;
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-buy-form-script"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-form')) {
    customElements.define('product-buy-form', class extends HTMLElement {
      connectedCallback() {
        const dataScript = this.querySelector('[data-buy-form-variants]');
        if (!dataScript) return;

        let variants;
        try {
          variants = JSON.parse(dataScript.textContent);
        } catch (error) {
          return;
        }

        this.idInput = this.querySelector('[data-buy-form-id]');
        this.submitButton = this.querySelector('[data-buy-form-submit]');
        this.submitText = this.querySelector('[data-buy-form-submit-text]');
        this.errorEl = this.querySelector('[data-buy-form-error]');
        this.statusEl = this.querySelector('[data-buy-form-status]');
        this.variantsByKey = new Map(variants.map((variant) => [variant.options.join('///'), variant]));

        const initial = variants.find((variant) => String(variant.id) === this.idInput.value);
        // Every option position starts at the initial variant's value; only
        // the positions that actually have a radio (the choosable ones) ever
        // change from here — a skipped single-value position keeps its one
        // possible value for the form's whole lifetime.
        this.currentOptions = initial ? initial.options.slice() : [];

        this.addEventListener('change', (event) => {
          const radio = event.target.closest('[data-buy-form-option]');
          if (!radio) return;
          const position = Number(radio.dataset.buyFormOption) - 1;
          this.currentOptions[position] = radio.value;

          const current = this.querySelector(
            `[data-buy-form-option-current="${radio.dataset.buyFormOption}"]`
          );
          if (current) current.textContent = radio.value;

          this.hideError();
          const variant = this.variantsByKey.get(this.currentOptions.join('///'));
          // A pair of values with no variant behind it (a kit whose one
          // combination was withdrawn): the chips show the new choice, so
          // nothing may still buy the previous variant.
          if (variant) {
            this.applyVariant(variant);
            this.announce(this.dataset.variantStatus, {
              __VARIANT__: variant.options.join(', '),
              __PRICE__: variant.available
                ? this.formatMoney(variant.price)
                : this.submitButton ? this.submitButton.dataset.soldOutText : '',
            });
          } else {
            this.setBuyable(false);
            this.announce(this.dataset.variantStatus, {
              __VARIANT__: this.currentOptions.join(', '),
              __PRICE__: this.submitButton ? this.submitButton.dataset.soldOutText : '',
            });
          }
        });

        this.form = this.querySelector('form');
        if (this.form) this.form.addEventListener('submit', (event) => this.addToCart(event));

        this.addEventListener('click', (event) => {
          const step = event.target.closest('[data-quantity-step]');
          if (!step) return;
          const input = this.querySelector('[name="quantity"]');
          if (!input) return;
          const next = Math.max(1, Number(input.value || 1) + Number(step.dataset.quantityStep));
          input.value = next;
          this.announce(this.dataset.quantityStatus, { __COUNT__: next });
        });
      }

      // Every button that submits this form: its own, plus the phone buy
      // bar's and the section nav's, which point at it with `form="…"`.
      get buttons() {
        const formId = this.form ? this.form.getAttribute('id') : null;
        if (!formId) return this.submitButton ? [this.submitButton] : [];
        return Array.from(
          document.querySelectorAll(`#${formId} [type="submit"], button[form="${formId}"]`)
        );
      }

      // One switch for every button of the form, so the bars can never
      // offer "Dodaj do koszyka" for a variant the form itself refuses.
      setBuyable(available) {
        const label = available
          ? this.submitButton && this.submitButton.dataset.addToCartText
          : this.submitButton && this.submitButton.dataset.soldOutText;
        this.buttons.forEach((button) => {
          button.disabled = !available;
          if (!label) return;
          const text = button === this.submitButton ? this.submitText : button;
          if (text) text.textContent = label;
        });
      }

      // Writes one sentence into the form's status region; `values` fills
      // the placeholders of the translated template.
      announce(template, values) {
        if (!this.statusEl || !template) return;
        let text = template;
        Object.entries(values).forEach(([key, value]) => {
          text = text.replace(key, value);
        });
        this.statusEl.textContent = text;
      }

      showError(message) {
        if (!this.errorEl || !message) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
        // The phone bar and the section nav submit this form from far
        // away: bring the message to where the shopper is looking.
        const box = this.errorEl.getBoundingClientRect();
        if (box.top < 0 || box.bottom > window.innerHeight) {
          const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.errorEl.scrollIntoView({ block: 'center', behavior: smooth ? 'smooth' : 'auto' });
        }
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }

      // Adds to the cart in place and lets the header open its cart panel,
      // instead of the form's own trip to the bare /cart page. The request
      // asks Shopify for the header section in the same round trip, so the
      // panel shows the new line without a second fetch. Every buy button on
      // the page goes through here: the phone buy bar and the section nav
      // submit this same form. Without JavaScript or a cart panel, the form
      // submits the way any product form does.
      //
      // A refused add (sold out, a quantity limit, a variant that is gone)
      // or a lost connection is told here, under the button, in the shop's
      // words. The form is never resubmitted as a plain POST: Shopify answers
      // a refused one with its own English error page, outside the shop, and
      // after a lost response the retry could add the product twice.
      addToCart(event) {
        const addUrl = this.dataset.cartAddUrl;

        // Add-ons (the picker's "zestaw z dodatkiem": hidden, nameless
        // inputs the quick-buy panel puts in the form) go in the same
        // request as the product, each in the product's quantity, so kit
        // and add-on land in the cart together or not at all.
        const addonIds = Array.from(this.form.querySelectorAll('[data-buy-addon]'))
          .map((input) => Number(input.value))
          .filter((id) => id > 0);
        let body;
        if (addonIds.length) {
          const quantityInput = this.form.querySelector('[name="quantity"]');
          const quantity = Math.max(1, Number(quantityInput ? quantityInput.value : 1) || 1);
          const items = [{ id: Number(this.idInput.value), quantity }];
          addonIds.forEach((id) => items.push({ id, quantity }));
          body = { items };
        } else {
          body = new FormData(this.form);
        }

        if (this.adding) {
          event.preventDefault();
          return;
        }
        // The shared request lives in header.liquid (window.cnsAddToCart);
        // without it, or without a cart panel, the form submits as usual.
        const request = window.cnsAddToCart ? window.cnsAddToCart(addUrl, body, event.submitter) : null;
        if (!request) return;
        event.preventDefault();
        this.adding = true;
        this.hideError();
        const buttons = this.buttons;
        buttons.forEach((button) => button.setAttribute('aria-busy', 'true'));

        request
          .then(({ outcome }) => {
            if (outcome === 'offline') this.showError(this.dataset.offlineText);
            else if (outcome === 'refused') this.showError(this.dataset.errorText);
            else if (outcome === 'no-panel') window.location.assign(this.dataset.cartUrl);
          })
          .finally(() => {
            this.adding = false;
            buttons.forEach((button) => button.removeAttribute('aria-busy'));
          });
      }

      applyVariant(variant) {
        this.idInput.value = variant.id;
        this.setBuyable(variant.available);
        this.updatePrice(variant);

        // A panel's form (see `scoped` in product-buy-form.liquid) is a
        // guest on someone else's page: it leaves the address bar alone.
        if (!this.scoped) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }

        // Any per-variant content elsewhere on the page — a bundle's "W
        // zestawie" panels, a single product's ingredients/nutrition blocks —
        // shows only the block matching this variant.
        this.variantScope.querySelectorAll('[data-variant-id]').forEach((el) => {
          if (!this.owns(el)) return;
          el.hidden = el.dataset.variantId !== String(variant.id);
        });

        // `options` (the value strings in position order) rides along so a
        // bundle page's own JS can match a component product's variant by
        // value NAME rather than by ID — the two products' variant IDs are
        // never the same thing, only their option value text can line up
        // (e.g. both offering a "Waniliowo-śmietankowy" flavor). See
        // main-bundle.liquid's "W zestawie" panels for the consumer.
        // `scoped` tells the page's own listeners (the "Wybrano:" line, the
        // component panels) that a panel's product changed, not the page's,
        // so they leave their text alone (audit H003).
        document.dispatchEvent(new CustomEvent('cns:variant-change', { detail: { variantId: variant.id, options: variant.options, scoped: this.scoped } }));
      }

      // A form that owns its page speaks for every price block on it, not
      // just the first: a kit page also carries one in its sticky nav and
      // one in the phone buy bar, and all of them track the same selected
      // variant. A panel's form speaks only for the prices inside it.
      get scoped() {
        return this.hasAttribute('data-scoped');
      }

      // A scoped form speaks for its own panel — the price above it lives
      // there too, outside the form — and for nothing beyond it.
      // A page's form speaks for the page's main content, never for the cart
      // panel in the header, whose kit components carry `data-variant-id`
      // too (audit F176).
      get variantScope() {
        if (!this.scoped) return document.getElementById('MainContent') || document;
        return this.closest('[data-buy-scope]') || this;
      }

      // A page's form leaves alone what sits in a panel's own scope: a
      // kit page holds the add-on quick-buy dialog inside #MainContent, and
      // the kit's price must not land in it (audit H004).
      owns(el) {
        return this.scoped || !el.closest('[data-buy-scope]');
      }

      // Prices as the `money_without_trailing_zeros` filter prints them, from
      // the shop's own money format (Settings → General), so a price redrawn
      // here reads exactly like one printed on the server, thousands
      // separator included (audit F094), and a whole price without its ",00"
      // (owner, 2026-10-29).
      formatMoney(cents) {
        const format = this.dataset.moneyFormat || '';
        const placeholder = /\{\{\s*(\w+)\s*\}\}/;
        const whole_price = cents % 100 === 0;
        if (!placeholder.test(format)) {
          return new Intl.NumberFormat(document.documentElement.lang || 'pl', { minimumFractionDigits: whole_price ? 0 : 2 }).format(cents / 100);
        }
        const kinds = {
          amount: [2, ',', '.'],
          amount_no_decimals: [0, ',', '.'],
          amount_with_comma_separator: [2, '.', ','],
          amount_no_decimals_with_comma_separator: [0, '.', ','],
          amount_with_space_separator: [2, ' ', ','],
          amount_no_decimals_with_space_separator: [0, ' ', ','],
          amount_with_apostrophe_separator: [2, "'", '.'],
          amount_with_period_and_space_separator: [2, ' ', '.'],
        };
        const [precision, thousands, decimal] = kinds[format.match(placeholder)[1]] || kinds.amount;
        const [whole, fraction] = (cents / 100).toFixed(precision).split('.');
        const number = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction && !whole_price ? decimal + fraction : '');
        return format.replace(placeholder, number);
      }

      updatePrice(variant) {
        this.variantScope.querySelectorAll('.cns-price').forEach((priceEl) => {
          if (!this.owns(priceEl)) return;
          const mainEl = priceEl.querySelector('.cns-price__main');
          if (mainEl) mainEl.textContent = this.formatMoney(variant.price);

          const unitCount = Number(priceEl.dataset.priceUnitCount);
          if (!(unitCount > 0)) return;
          const unitPrice = this.formatMoney(Math.round(variant.price / unitCount));

          // kit-price's `page`/`compact` layouts keep the unit's wording in
          // markup and only the number in this element; the card layout
          // rebuilds the whole line from its translated template instead.
          const valueEl = priceEl.querySelector('[data-price-unit-value]');
          if (valueEl) {
            valueEl.textContent = unitPrice;
            return;
          }

          const unitEl = priceEl.querySelector('.cns-price__unit');
          const template = priceEl.dataset.priceUnitTemplate;
          if (unitEl && template) {
            unitEl.textContent = template.replace('__PRICE__', unitPrice);
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    // Only for galleries rendered with `link_variants` (see the doc comment).
  // Runs again for a section the theme editor re-renders, and drops the old
  // listener when it goes (audit F179).
  (function () {
    var init = function (scope) {
      scope.querySelectorAll('[data-gallery-variants]').forEach(function (gallery) {
        if (gallery.dataset.cnsReady) return;
        gallery.dataset.cnsReady = '1';

        // Thumbnail → variant, through the buy form's own option radios.
        gallery.addEventListener('change', function (event) {
          var radio = event.target.closest('[data-gallery-radio]');
          if (!radio) return;
          var options;
          try {
            options = JSON.parse(radio.dataset.variantOptions);
          } catch (error) {
            return;
          }
          var form = document.querySelector('product-buy-form');
          if (!form) return;
          options.forEach(function (value, index) {
            var inputs = form.querySelectorAll('[data-buy-form-option="' + (index + 1) + '"]');
            var input = Array.prototype.find.call(inputs, function (candidate) {
              return candidate.value === value;
            });
            if (input && !input.checked) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });

        // Variant → photo; a variant of this product with no photo of its
        // own brings back the default one. Setting `checked` fires no change
        // event, so this never loops back into the handler above.
        var productVariantIds = (gallery.dataset.productVariantIds || '').split(' ');
        var onVariantChange = function (event) {
          var id = String((event.detail && event.detail.variantId) || '');
          if (!id || productVariantIds.indexOf(id) === -1) return;
          var radios = gallery.querySelectorAll('[data-gallery-radio]');
          var match = Array.prototype.find.call(radios, function (radio) {
            return radio.dataset.variantIds.split(' ').indexOf(id) !== -1;
          });
          if (!match) match = gallery.querySelector('[data-gallery-default]');
          if (match) match.checked = true;
        };
        document.addEventListener('cns:variant-change', onVariantChange);
        gallery.cnsCleanup = function () {
          document.removeEventListener('cns:variant-change', onVariantChange);
        };
      });
    };

    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-gallery-variants]').forEach(function (gallery) {
        if (gallery.cnsCleanup) gallery.cnsCleanup();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cns-search')) {
    const MIN_LENGTH = 2;
    const DELAY = 200;

    customElements.define('cns-search', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="search"]');
        this.clearButton = this.querySelector('[data-search-clear]');
        this.body = this.querySelector('[data-search-body]');
        this.results = this.querySelector('[data-search-results]');
        this.status = this.querySelector('[data-search-status]');
        this.errorTemplate = this.querySelector('template[data-search-error]');
        this.cache = new Map();
        this.shown = '';
        this.timer = null;
        this.controller = null;

        this.input.addEventListener('input', () => this.onInput());
        // A query left in the field (the results page fills it in) gets
        // its results when the panel opens, not on every page load.
        this.input.addEventListener('focus', () => {
          const query = this.query();
          if (query.length >= MIN_LENGTH && query !== this.shown) this.search(query);
        });
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
        this.clearButton.addEventListener('click', () => this.clear());
        this.addEventListener('click', (event) => this.onClick(event));
        this.addEventListener('keydown', (event) => this.onKeydown(event));
        this.syncClear();
      }

      query() {
        return this.input.value.trim();
      }

      syncClear() {
        this.clearButton.hidden = this.input.value === '';
      }

      onInput() {
        this.syncClear();
        window.clearTimeout(this.timer);
        const query = this.query();
        if (query.length < MIN_LENGTH) {
          this.showStart();
          return;
        }
        this.timer = window.setTimeout(() => this.search(query), DELAY);
      }

      showStart() {
        this.abort();
        this.setLoading(false);
        this.shown = '';
        this.results.replaceChildren();
        this.dataset.state = 'initial';
        this.status.textContent = '';
      }

      abort() {
        if (this.controller) this.controller.abort();
        this.controller = null;
      }

      setLoading(loading) {
        this.toggleAttribute('data-loading', loading);
        this.results.setAttribute('aria-busy', loading ? 'true' : 'false');
      }

      async search(query) {
        window.clearTimeout(this.timer);
        this.abort();
        if (this.cache.has(query)) {
          this.render(query, this.cache.get(query));
          return;
        }
        const controller = new AbortController();
        this.controller = controller;
        this.setLoading(true);
        // A synonym from the theme settings (search-synonyms.liquid) is
        // searched under its rule's word; more products than the five shown
        // come back, so the grouping can put the name matches first.
        const searched = (window.cnsSearchSynonym && window.cnsSearchSynonym(query)) || query;
        const params = new URLSearchParams({
          q: searched,
          section_id: 'predictive-search',
          'resources[type]': 'product,collection,page',
          'resources[limit]': '10',
          'resources[limit_scope]': 'each',
          'resources[options][fields]': 'title,body',
        });
        try {
          const response = await fetch(`${this.dataset.suggestUrl}?${params}`, { signal: controller.signal });
          if (!response.ok) throw new Error(`Predictive search: ${response.status}`);
          const html = await response.text();
          this.cache.set(query, html);
          if (this.query() === query) this.render(query, html);
        } catch (error) {
          if (error.name === 'AbortError') return;
          if (this.query() === query) this.showError(query);
        } finally {
          if (this.controller === controller) {
            this.controller = null;
            this.setLoading(false);
          }
        }
      }

      render(query, html) {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.cns-search-results');
        if (!fresh) {
          this.showError(query);
          return;
        }
        this.setLoading(false);
        this.results.replaceChildren(fresh);
        this.shown = query;
        this.dataset.state = Number(fresh.dataset.total) > 0 ? 'results' : 'empty';
        this.body.scrollTop = 0;
        this.announce(fresh.dataset.announce);
        if (this.focusResultsOnRender) {
          this.focusResultsOnRender = false;
          this.results.focus({ preventScroll: true });
        }
      }

      showError(query) {
        this.setLoading(false);
        const content = this.errorTemplate.content.cloneNode(true);
        const link = content.querySelector('[data-search-error-link]');
        if (link) link.href = `${this.form.action}?${new URLSearchParams(new FormData(this.form))}`;
        this.results.replaceChildren(content);
        this.shown = '';
        this.dataset.state = 'error';
        this.announce(this.results.querySelector('.cns-search-results__empty-title')?.textContent.trim());
      }

      // Cleared first and written a moment later, so the same sentence
      // twice in a row is read twice.
      announce(text) {
        this.status.textContent = '';
        window.setTimeout(() => {
          this.status.textContent = text || '';
        }, 150);
      }

      clear() {
        this.input.value = '';
        this.onInput();
        this.input.focus();
      }

      onClick(event) {
        const shortcut = event.target.closest('[data-search-term]');
        if (!shortcut) return;
        this.input.value = shortcut.dataset.searchTerm;
        this.syncClear();
        this.search(this.query());
        // A tap leaves the keyboard down, so the results stay in view; a
        // mouse or the keyboard goes back to the field.
        if (event.pointerType === 'touch' || event.pointerType === 'pen') {
          // The results are still hidden (state "initial") until the answer
          // is drawn: focus waits for render() (audit H040).
          this.focusResultsOnRender = true;
        } else {
          this.input.focus();
        }
      }

      // Enter in the field goes to the full results page, which lists
      // products only: when the live results found only a category or a
      // page, it opens the first of them instead of an empty results page.
      // Enter on a focused result is that link's own.
      onSubmit(event) {
        const query = this.query();
        if (!query) {
          event.preventDefault();
          return;
        }
        const shown = this.results.firstElementChild;
        if (shown && this.shown === query && shown.dataset.products === '0') {
          const first = shown.querySelector('a[href]');
          if (first) {
            event.preventDefault();
            window.location.assign(first.href);
          }
        }
      }

      // Up and down move through what is on screen under the field: the
      // results, or the shortcuts and products. Up from the first goes back
      // to the field.
      onKeydown(event) {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        const items = Array.from(this.body.querySelectorAll('a[href], button[data-search-term]'))
          .filter((item) => item.getClientRects().length > 0);
        if (!items.length) return;
        const active = document.activeElement;
        if (active === this.input) {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            items[0].focus();
          }
          return;
        }
        const index = items.indexOf(active);
        if (index === -1) return;
        event.preventDefault();
        if (event.key === 'ArrowDown') {
          items[Math.min(index + 1, items.length - 1)].focus();
        } else if (index === 0) {
          this.input.focus();
        } else {
          items[index - 1].focus();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-synonyms"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.cnsSearchSynonym) return;

    var rules = null;
    function loadRules() {
      if (rules) return rules;
      rules = [];
      var source = document.getElementById('cns-search-synonyms');
      if (!source) return rules;
      var text = '';
      try { text = JSON.parse(source.textContent) || ''; } catch (error) { return rules; }
      text.split(/\r?\n/).forEach(function (line) {
        var parts = line.split('=');
        if (parts.length !== 2) return;
        var target = normalise(parts[1]);
        if (!target) return;
        parts[0].split(',').forEach(function (word) {
          var key = plain(word);
          if (key && key !== plain(target)) rules.push({ key: key.split(' '), target: target });
        });
      });
      // Longer phrases first, so "olej rybi" wins over "olej".
      rules.sort(function (a, b) { return b.key.length - a.key.length; });
      return rules;
    }

    function normalise(text) {
      return String(text || '').toLowerCase().replace(/\s+/g, ' ').trim();
    }

    // Without Polish letters, so a rule written "odżywka" also catches a
    // shopper typing "odzywka", and the other way round.
    function plain(text) {
      return normalise(text).normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ł/g, 'l');
    }

    // Returns the query to search for, or null when no rule applies. The
    // words are compared without Polish letters; the rest of the query
    // keeps what the shopper typed.
    window.cnsSearchSynonym = function (query) {
      var words = normalise(query).split(' ').filter(Boolean);
      if (!words.length) return null;
      var bare = words.map(plain);
      var out = [];
      var changed = false;
      var i = 0;
      while (i < words.length) {
        var hit = null;
        loadRules().some(function (rule) {
          var n = rule.key.length;
          if (bare.slice(i, i + n).join(' ') === rule.key.join(' ')) {
            hit = rule;
            return true;
          }
          return false;
        });
        if (hit) {
          out.push(hit.target);
          i += hit.key.length;
          changed = true;
        } else {
          out.push(words[i]);
          i += 1;
        }
      }
      return changed ? out.join(' ') : null;
    };

    function isSearchForm(form) {
      var action = form.getAttribute('action') || '';
      return /\/search\/?$/.test(action.split('?')[0]) && form.querySelector('[name="q"]');
    }

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !isSearchForm(form)) return;
      var field = form.querySelector('[name="q"]');
      var mapped = window.cnsSearchSynonym(field.value);
      var old = form.querySelector('input[name="syn"]');
      if (old) old.remove();
      if (!mapped) return;
      var syn = document.createElement('input');
      syn.type = 'hidden';
      syn.name = 'syn';
      syn.value = field.value.trim();
      form.appendChild(syn);
      field.value = mapped;
    }, true);

    // The results page: follow a rule for a link that carries a mapped
    // word, and say what was searched for after a mapped search.
    function onResultsPage() {
      var note = document.querySelector('[data-search-synonym-note]');
      if (!note) return;
      var params = new URLSearchParams(window.location.search);
      var query = params.get('q') || '';
      var typed = params.get('syn');
      if (!typed) {
        var mapped = window.cnsSearchSynonym(query);
        if (mapped) {
          params.set('q', mapped);
          params.set('syn', query);
          window.location.replace(window.location.pathname + '?' + params.toString());
        }
        return;
      }
      note.textContent = (note.dataset.template || '')
        .replace('[wynik]', query)
        .replace('[wpisano]', typed);
      note.hidden = false;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onResultsPage);
    } else {
      onResultsPage();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section-jump"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cnsSectionJump) return;
    window.__cnsSectionJump = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-section-jump]');
      if (!link) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var hash = link.getAttribute('href') || '';
      if (hash.charAt(0) !== '#') return;
      var section = document.getElementById(hash.slice(1));
      if (!section) return;
      var heading = section.querySelector('h2') || section;
      event.preventDefault();

      var guarantee = document.querySelector('.cns-guarantee');
      var nav = document.querySelector('cns-sticky-nav');
      var offset = (guarantee ? guarantee.getBoundingClientRect().height : 0) +
        (nav ? nav.getBoundingClientRect().height : 0) + 16;
      var top = heading.getBoundingClientRect().top + window.scrollY - offset;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', hash);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section-nav"] && !Shopify.designMode) return;
  try {
    // Runs again for a section the theme editor re-renders, and drops the old
  // listeners when it goes (audit F179).
  (function () {
    var init = function (scope) {
      scope.querySelectorAll('[data-section-nav]').forEach(function (nav) {
        if (nav.dataset.cnsReady) return;
        nav.dataset.cnsReady = '1';
        var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
        var bands = links.map(function (link) {
          return document.getElementById(link.getAttribute('href').slice(1));
        });

        // The nav's own height, for the bands' scroll-margin-top: an anchor
        // jump then lands each band flush under this nav instead of under the
        // site header, where the nav would cover the band's heading.
        var setNavHeight = function () {
          document.documentElement.style.setProperty('--cns-section-nav-height', nav.offsetHeight + 'px');
        };
        setNavHeight();
        var resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(setNavHeight) : null;
        if (resizeObserver) resizeObserver.observe(nav);

        // On a phone the links scroll sideways; keep the current one in view
        // (centred) so its underline is never off screen. Only the strip
        // scrolls — never the page.
        var strip = nav.querySelector('.cns-section-nav__links');
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        var revealLink = function (link) {
          if (!strip || strip.scrollWidth <= strip.clientWidth) return;
          var stripBox = strip.getBoundingClientRect();
          var linkBox = link.getBoundingClientRect();
          if (linkBox.left >= stripBox.left && linkBox.right <= stripBox.right) return;
          strip.scrollTo({
            left: strip.scrollLeft + linkBox.left - stripBox.left - (stripBox.width - linkBox.width) / 2,
            behavior: reduceMotion.matches ? 'auto' : 'smooth',
          });
        };

        // A band is current once its top edge has reached the reading line:
        // a little under this nav (up to 240 px, or 30 % of a short screen),
        // where the shopper's eyes already are once a new band's heading
        // comes up — switching only when the band touched the nav felt a
        // touch late on a desktop. At the very bottom of the page the last
        // band may never get that high, so there the last band on screen
        // wins. Measured on scroll (throttled to one read per frame) because
        // the reading line moves with the sticky header, which a fixed
        // IntersectionObserver margin can't follow.
        var currentLink = null;
        var updateCurrent = function () {
          var line = nav.getBoundingClientRect().bottom + Math.min(window.innerHeight * 0.3, 240);
          var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
          var best = -1;
          var bestTop = -Infinity;
          bands.forEach(function (band, index) {
            if (!band) return;
            var top = band.getBoundingClientRect().top;
            var reached = top <= line || (atBottom && top < window.innerHeight);
            if (reached && top > bestTop) {
              best = index;
              bestTop = top;
            }
          });
          var next = best === -1 ? null : links[best];
          if (next === currentLink) return;
          if (currentLink) currentLink.removeAttribute('aria-current');
          if (next) next.setAttribute('aria-current', 'true');
          currentLink = next;
          if (next) revealLink(next);
        };

        var stopScrollWatch = window.cnsOnScrollFrame(updateCurrent);

        nav.cnsCleanup = function () {
          stopScrollWatch();
          if (resizeObserver) resizeObserver.disconnect();
        };
      });
    };

    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-section-nav]').forEach(function (nav) {
        if (nav.cnsCleanup) nav.cnsCleanup();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    // Runs again for a section the theme editor re-renders, and drops the old
  // listeners when it goes (audit F179).
  (function () {
    var init = function (scope) {
      scope.querySelectorAll('[data-sticky-buy]').forEach(function (bar) {
        if (bar.dataset.cnsReady) return;
        bar.dataset.cnsReady = '1';
        var form = document.getElementById(bar.dataset.stickyBuy);
        var buyButton = form && form.querySelector('[data-buy-form-submit]');
        if (!buyButton) return;

        // Two buy buttons are never on screen together. The bar steps aside
        // the moment the form's own button would start to show above it, and
        // comes back only once that button is well behind it again (or well
        // under the site header at the top). Both edges are measured from the
        // elements' own boxes on every scroll frame rather than from the
        // viewport: a phone's toolbar sliding in and out changes the viewport
        // mid-scroll, but never where these two sit relative to each other.
        // The slack between the two switch points keeps the bar from
        // flickering when the page rests right on an edge.
        var SLACK = 40;
        var rootStyle = getComputedStyle(document.documentElement);
        var shown = false;
        // At the end of the page the bar steps aside for the footer, whose
        // last row (cookie settings, payment marks) it would otherwise cover
        // (audit F134).
        var footer = document.querySelector('.cns-footer');

        var update = function () {
          var headerBottom =
            (parseFloat(rootStyle.getPropertyValue('--cns-guarantee-height')) || 0) +
            (parseFloat(rootStyle.getPropertyValue('--cns-sticky-navigation-height')) || 0);
          var barTop = bar.getBoundingClientRect().top;
          var button = buyButton.getBoundingClientRect();
          if (shown) {
            if (button.top < barTop && button.bottom > headerBottom) shown = false;
          } else if (button.top >= barTop + SLACK || button.bottom <= headerBottom - SLACK) {
            shown = true;
          }
          var atFooter = footer ? footer.getBoundingClientRect().top < barTop : false;
          bar.classList.toggle('cns-sticky-buy--off', !shown || atFooter);
        };

        var stopScrollWatch = window.cnsOnScrollFrame(update);

        bar.cnsCleanup = function () {
          stopScrollWatch();
        };
      });
    };

    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-sticky-buy]').forEach(function (bar) {
        if (bar.cnsCleanup) bar.cnsCleanup();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-summary"] && !Shopify.designMode) return;
  try {
    document.addEventListener('cns:variant-change', function (event) {
    // A panel's form (an add-on's quick buy) is not the page's choice.
    if (event.detail && event.detail.scoped) return;
    var options = event.detail && event.detail.options;
    if (!options) return;
    document.querySelectorAll('[data-variant-summary]').forEach(function (el) {
      var values = el.dataset.variantSummary
        .split(',')
        .filter(Boolean)
        .map(function (position) {
          return options[Number(position) - 1];
        });
      el.textContent = values.join(' · ');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
